// Badge de estado FE - Sprint 35 (migrado a XLBadge en Sprint 44).
// Conserva la API { fe, size } para no romper VentaForm/VentasList.
// Internamente usa XLBadge para que el look sea identico al Estado general.
import XLBadge from '../../components/xl/XLBadge';

const MAP = {
  pendiente: { variant: 'neutral', label: 'Pendiente' },
  enviado:   { variant: 'info',    label: 'Enviado' },
  aceptado:  { variant: 'success', label: 'Aceptado' },
  rechazado: { variant: 'danger',  label: 'Rechazado' },
};

export default function FEStatusBadge({ fe }) {
  if (!fe || !fe.estado) {
    return (
      <XLBadge variant="neutral" dot>Sin FE</XLBadge>
    );
  }
  const cfg = MAP[fe.estado] || MAP.pendiente;
  return (
    <XLBadge
      variant={cfg.variant}
      dot
      title={fe.mensaje_respuesta || ''}
    >
      {cfg.label}
    </XLBadge>
  );
}
